import React, { useContext,useEffect } from 'react'
import UserContext from '../../contexts/UserContext'
import { useNavigate } from 'react-router-dom';
import authenticate from '../../utils/Authenticate';

const Home = () => {
    const {user,setUser} = useContext(UserContext);
    const navigate = useNavigate();
  
    const checkLogin = () => {
        if(user?.role === "Zone Coordinator"){
            navigate("/zc/home")
          }else if(user?.role === "Supplier"){
            const userData = user;
            navigate("/supplier/home",{state:{userData}})
          }else if(user?.role === "Purchase" || user?.role === "Admin" || user?.role === "CityAdmin"){
            navigate("/central/home")
          }else if(user?.role === "SuperAdmin"){
            navigate(user?.tenant ? "/central/home" : "/superadmin/home")
          }else if(user?.role === "Silat"){
            navigate("/silat/home")
          }
    }
    useEffect( () => {
        async function startup(){
          if(!user){
            await authenticate(setUser,navigate);
            checkLogin();
          }
          if(user){
            checkLogin();
          }
        }
        startup();
      },[user])  
  return (
    <div>
        <img
            className="mx-auto w-auto"
            src="fmb_logo.png"
          />
    </div>
  )
}

export default Home